import React, { useState } from 'react';

import {useTranslation} from "react-i18next";


const ItemDetailsBlockAddonsGroup = ({ addonGroups = [], onAddonSelect }) => {
    const [selectedAddons, setSelectedAddons] = useState({});

    const { t } = useTranslation();

    const getSelectionCriteriaMessage = (group) => {
        if (group.max_selections === 1) {
            return t(
                'item_details_block_addons_group_description_select_one_option_only_template'
            );
        } else if (group.min_selections > 0 && group.max_selections > 1) {
            if (group.min_selections === group.max_selections) {
                return t(
                    'item_details_block_addons_group_description_select_exact_options_template',
                    { count: group.min_selections }
                );
            }
            return t(
                'item_details_block_addons_group_description_select_between_options_template',
                { min: group.min_selections, max: group.max_selections }
            );
        } else if (group.is_required) {
            return t(
                'item_details_block_addons_group_description_at_least_selections_required_template',
                { count: group.min_selections }
            );
        }
        return t(
            'item_details_block_addons_group_description_optional_selection_template'
        );
    };

    const handleAddonChange = (groupIndex, group, addon) => {
        setSelectedAddons(prev => {
            const key = `group-${groupIndex}`;
            let updatedAll = { ...prev };

            if (group.max_selections === 1) {
                const current = prev[key]?.[0] || null;
                if (current?.id === addon.id) {
                    // Deselect if not required
                    if (!group.is_required) {
                        updatedAll[key] = [];
                        onAddonSelect(groupIndex, []);
                    }
                } else {
                    updatedAll[key] = [addon];
                    onAddonSelect(groupIndex, [addon]);
                }
            } else {
                const current = prev[key] || [];
                const isSelected = current.some(a => a.id === addon.id);
                let updated = [...current];

                if (isSelected) {
                    if (updated.length - 1 < group.min_selections) return prev;
                    updated = updated.filter(a => a.id !== addon.id);
                } else {
                    if (updated.length + 1 > group.max_selections) return prev;
                    updated.push(addon);
                }

                updatedAll[key] = updated;
                onAddonSelect(groupIndex, updated);
            }

            return updatedAll;
        });
    };


    const isSelected = (groupIndex, addon) => {
        const key = `group-${groupIndex}`;
        return selectedAddons[key]?.some(a => a.id === addon.id);
    };

    return (
        <div className="item_details_block_addons_group">
            {addonGroups.map((group, groupIndex) => {
                const selectedCount = selectedAddons[`group-${groupIndex}`]?.length || 0;
                return (
                    <div className="item_details_block_addons_group" key={group.id}>
                        <div className="item_details_block_addons_title bold">
                            {group.name} {group.is_required && <span className="text-red-500">*</span>}
                        </div>

                        <div className="item_details_block_addons_group_description">
                            {getSelectionCriteriaMessage(group)}
                        </div>

                        <div className="item_details_block_addons_group_list">
                            {group.addon_id.map((addon) => {
                                const selected = isSelected(groupIndex, addon);
                                const disabled = group.max_selections > 1 && !selected && selectedCount >= group.max_selections;


                                const inputType =
                                    group.max_selections === 1 && group.is_required
                                        ? 'radio'
                                        : 'checkbox';


                                return (
                                    <div
                                        key={addon.id}
                                        className={`item_details_block_addons_group_item flex ${selected ? 'item_details_block_addons_group_item_selected' : ''} ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                                        onClick={() => !disabled && handleAddonChange(groupIndex, group, addon)}
                                    >

                                        <input
                                            className="item_details_block_addons_group_item_indicator"
                                            type={inputType}
                                            name={`group-${groupIndex}`}
                                            value={addon.id}
                                            checked={selected}
                                            disabled={disabled}
                                            readOnly
                                        />

                                        <div className={`item_details_block_addons_group_item_name flex_1 bold ${selected ? 'item_details_block_addons_group_item_name_selected' : ''}`}>
                                            {addon.name}
                                        </div>

                                        {Number(addon.price) > 0 && (
                                            <div className={`item_details_block_addons_group_item_price ${selected ? 'item_details_block_addons_group_item_price_selected' : ''}`}>
                                                {addon.price}
                                            </div>
                                        )}

                                        {Number(addon.image) > 0 && (
                                            <img className="item_details_block_addons_group_item_icon" src={addon.image[0].path}  />

                                        )}

                                        {Array.isArray(addon.image) && addon.image.length > 0 && addon.image[0]?.path && (
                                            <img className="item_details_block_addons_group_item_icon" src={addon.image[0].path} />
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default ItemDetailsBlockAddonsGroup;
